module.exports = __webpack_public_path__ + "bb0848172a0151321b56df877ffde804.MP3";